<template>
    <div class="change-record-box">
        <el-steps direction="vertical" space="100">
            <el-step :title="item.user.realname" v-for="(item, index) in recordList" :key="index">
                <!-- <div slot="description" class="confirm-desc">修改人：{{ item.user.realname }}</div> -->
                <div slot="description" class="confirm-desc">修改时间：{{ item.create_time }}</div>
                <div slot="description" class="confirm-desc">
                    <div v-for="(field, k) in item.changed_data" :key="k">
                        <div v-if="fields[k] != undefined">
                            <template v-if="k == 'status'"> {{ fields[k] }}:{{ statusSet[field] }} </template>
                            <template v-if="k == 'other_price'">
                                <template v-if="Array.isArray(field)">
                                    <div v-for="(other, n) in field" :key="k + n">
                                        <span>{{ other.name }}: </span>
                                        <span>{{ other.price }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-for="(other, n) in JSON.parse(field)" :key="k + n">
                                        <span>{{ other.name }}: </span>
                                        <span>{{ other.price }}</span>
                                    </div>
                                </template>
                            </template>
                            <template v-else> {{ fields[k] }}:{{ field }} </template>
                        </div>
                    </div>
                </div>
                <div slot="description" class="confirm-desc" v-if="item.before_update_data || item.changed_data.gross_profit">
                  <template>
                    毛利修改前：{{ item.before_update_data.gross_profit }} => 毛利修改后：{{
                        item.changed_data.gross_profit ? item.changed_data.gross_profit : '毛利未变化'
                    }}
                  </template>
                </div>
                <i class="el-icon-edit" slot="icon"></i>
            </el-step>
        </el-steps>
    </div>
</template>

<script>
export default {
    name: 'record',
    props: {
        recordList: {
            type: Array,
            value: []
        },
        fields: {
            type: Object,
            value: {}
        },
        statusSet: {
            type: Array,
            value: []
        }
    },
    data() {
        return {};
    }
};
</script>

<style scoped>
.change-record-box {
    margin-top: 20px;
    margin-bottom: 20px;
}
.confirm-desc,
.el-step__title.is-wait {
    color: #999;
}
</style>